import {
    Component,
    AfterViewInit,
    ViewChild,
    ElementRef,
    OnDestroy,
    EventEmitter,
    OnInit,
    ViewChildren,
    viewChild
} from '@angular/core';
import Expand from '@arcgis/core/widgets/Expand';
import LayerList from '@arcgis/core/widgets/LayerList';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import { MapService } from '../../services/map.service';
import { EnvironmentService } from '../../services/environment.service';
import Slider from '@arcgis/core/widgets/Slider';
import Legend from '@arcgis/core/widgets/Legend';
import Search from '@arcgis/core/widgets/Search';
import LayerSearchSource from '@arcgis/core/widgets/Search/LayerSearchSource';
import IdentifyParameters from '@arcgis/core/rest/support/IdentifyParameters';
import * as identify from '@arcgis/core/rest/identify';
import * as reactiveUtils from '@arcgis/core/core/reactiveUtils';
import { Chart, registerables } from 'chart.js';
import Graphic from '@arcgis/core/Graphic';
import StatisticDefinition from '@arcgis/core/rest/support/StatisticDefinition';
import FeatureTable from '@arcgis/core/widgets/FeatureTable';
import Query from '@arcgis/core/rest/support/Query';
import { executeQueryJSON } from '@arcgis/core/rest/query';
import { StaticsDataModel } from '@/interfaces/iStaticsDataModel';
import { CenterFilterModel } from '@/interfaces/iCenterFilterModel';
import { InfoPieComponent } from '@components/info-pie/info-pie.component';
import Handles from '@arcgis/core/core/Handles.js';
import { InfoLabelComponent } from '@components/info-label/info-label.component';
import { ArcPercentageLableComponent } from '@components/arc-percentage-lable/arc-percentage-lable.component';
import Measurement from "@arcgis/core/widgets/Measurement.js";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { PrintService } from '@services/print.service';
import { toPng } from 'html-to-image';
import { log } from 'console';
Chart.register(...registerables);
@Component({
    selector: 'app-baladya-map',
    templateUrl: './baladya-map.component.html',
    styleUrl: './baladya-map.component.scss'
})
export class BaladyaMapComponent implements AfterViewInit, OnDestroy, OnInit {
    ShowSearch: boolean = false;

    @ViewChild('mapView', { static: false }) mapElementRef?: ElementRef;
    @ViewChild('content', { static: true }) contentRef!: ElementRef;

    @ViewChild('madinahArialpercent') madinahInfoPie?: ArcPercentageLableComponent;
    @ViewChild('baladypercent') baladyInfoPie?: InfoPieComponent;
    @ViewChild('Donepercent') doneInfoPie?: ArcPercentageLableComponent;
    @ViewChild('allBaladey') Allbaladeyas?: InfoLabelComponent;
    // el = document.getElementById('content')

    private layerList: LayerList;

    baladyasList: CenterFilterModel[] = [];
    staticsData?: StaticsDataModel;
    private prevExtent = false;
    private preExtent: __esri.Extent | null = null;
    private currentExtent: __esri.Extent | null = null;
    private extentHistory = [];

    private extentHistoryIndx = 0;
    private nextExtent = false;
    l_zoomPrevBtn = document.getElementById('zoomPrevBtn');
    l_zoomNextBtn = document.getElementById('zoomNextBtn');

    mainPlanFields: any[];
    query;
    mainQuery;
    layer: FeatureLayer;
    url =
        'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5'; //this.mapService.finalPlansLayer

    layerPln = new FeatureLayer({
        url: this.url
    });
    newChart = {};
    mainQuery2;

    baladeyaNameOptions: string[] = [];
    baladeyaGeometry = {};
    neighNameOptions: string[] = [];
    neighGeom = {};
    planNumOptions: string[] = [];
    planNameOptions: string[] = [];
    planCaseOptions: string[] = [];
    planGeom = {};
    planFeature: any;

    planName: string = '';
    neighName: string = '';

    selectedBaladyaArr: string[] = [];

    parcelAreaSum: number | undefined;
    parcelCountSum: number | undefined;
    PlansCount: number | undefined;
    madinahPercent: number | undefined;
    baladyPercent: number | undefined;
    deliveredRERcount: number | undefined;
    advertised: number | undefined;
    AdInProgress: number | undefined;
    correctedCount: number | undefined;
    correctedpercentage: number | undefined;
    pendingCount: number | undefined;
    pendingPercentage: number | undefined;
    qualityControlCount: number | undefined;
    qualityControlPercentage: number | undefined;
    cancelledCount: number | undefined;
    cancelledPercentage: number | undefined;
    notCorrectedCount: number | undefined;
    notCorrectedPercentage: number | undefined;
    planApprovalCount: number | undefined;
    planApprovalpercentage: number | undefined;
    correctedApprovedCount: number | undefined;
    correctedApprovedPercent: number | undefined;

    totalEnjaz: number | undefined;
    allInjaz: number | undefined;
    baladyinjaz: number | undefined;

    flagg: boolean = false;
    planCaseFlag: boolean = false;
    selectedPlanCase: string = '';
    measureFlag: boolean = false;

    ShowTable: boolean = false;
    fullscreen = false;
    screenshotImgSrc: string;

    measureExpand: Expand;


    toggleFullScreen() {

        this.fullscreen = !this.fullscreen;
        let elem = document.documentElement as any;
        if (this.fullscreen) {
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.webkitRequestFullscreen) {
                /* Safari */
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                /* IE11 */
                elem.msRequestFullscreen();
            }
        } else {
            elem = document;
            if (elem.exitFullscreen) {
                elem.exitFullscreen();
            } else if (elem.webkitExitFullscreen) {
                /* Safari */
                elem.webkitExitFullscreen();
            } else if (elem.msExitFullscreen) {
                /* IE11 */
                elem.msExitFullscreen();
            }
        }
    }
    showtableFun() {
        this.ShowTable = !this.ShowTable;
        this.ShowSearch = false;
        this.showOverlayPopup = false;
        // this.layerPopup.classList.remove('active');
        // this.switchBetweenMap.classList.remove('active');
    }
    ShowSearchFun() {
        this.ShowSearch = !this.ShowSearch;
        this.ShowTable = false;
        this.showOverlayPopup = false;
        this.layerPopup.classList.remove('active');
        this.switchBetweenMap.classList.remove('active');
    }

    constructor(
        readonly environment: EnvironmentService,
        readonly mapService: MapService,
        private elementRef: ElementRef,
        private printService: PrintService
    ) { }

    //#region new Code

    startSearch(value: string) {
        // console.log(value);
    }
    async onBaladyaSelection(isChecked: boolean, index: number) {
        // debugger;

        let flag = true;
        if (index === -1) {
            for (let i = 0; i <= this.baladyasList.length - 1; i++) {
                this.baladyasList[i].isChecked = false;
            }
            // this.planCaseFlag=true;
            await this.filterSelectedBaladya();


        } else {
            this.baladyasList[index].isChecked = isChecked;
            for (let i = 0; i <= this.baladyasList.length - 1; i++) {
                if (this.baladyasList[i].isChecked == true) {
                    flag = false;
                }
            }
        }
        this.Allbaladeyas.isChecked = flag;
        // Reset the selected plan case to "All"
        this.selectedPlanCase = '';
    }

    getFakeData() {
        this.staticsData = {
            pieData: {
                aerialPhotographyPercentage: 75,
                baladyPercentage: this.baladyPercent,
                totalScannedPercentage: this.totalEnjaz
            },
            barData: {
                lables: ['حائل', 'الشرقية', 'حائل', 'الشرقية'],
                values: [25, 30, 40, 50]
            },
            statics: {
                targetedPlansCount: this.PlansCount,
                deliveredToRER: this.deliveredRERcount,
                isAdvertised: this.advertised,
                isAdInProgress: this.AdInProgress,
                corrected: this.correctedApprovedCount,
                correctedPercent: this.correctedApprovedPercent,
                pending: this.pendingCount,
                pendingPercent: this.pendingPercentage,
                qualityControl: this.qualityControlCount,
                qualityControlPercent: this.qualityControlPercentage,
                cancelled: this.cancelledCount,
                cancelledPercent: this.cancelledPercentage,
                notCorrected: this.notCorrectedCount,
                notCorrectedPercent: this.notCorrectedPercentage,
                totalAreasCount: this.parcelCountSum,
                totalAreasSize: this.parcelAreaSum,
                planApproval: this.planApprovalCount,
                planApprovalPercent: this.planApprovalpercentage,
                allProjectProgressPercentage: this.allInjaz
            }
        };
    }
    //#endregion

    toggleExpand() {
        if (this.measureExpand.expanded) {
            this.measureExpand.collapse();
        } else {
            this.measureExpand.expand();
        }
    }
    ngAfterViewInit(): void {


        this.mapService.initDefaultMap(this.mapElementRef);
        this.measure();
        this.mapService.addAllMapWidgets();

        // let node = document.createElement("div");
        // node.innerHTML = "I'm a real node!";

        let node = document.getElementById('ctr');

        let expand = new Expand({
            expandIconClass: 'esri-icon-right-arrow',
            view: this.mapService.mapView,
            content: node
        });

        // expand sequential search
        this.mapService.mapView?.ui.add(expand, 'bottom-right');

        //     // Initialize the Expand widget
        //     const measureExpand = new Expand({
        //     view: this.mapService.mapView,
        //     content: document.getElementById("measurementToolbar"),
        //     expandIcon: "chevron-right",
        //     label: "Measurements"
        //   });

        //   this.mapService.mapView.ui.add(measureExpand, "top-right");



        //-----------------------------------

        // const layerUrl = 'http://192.168.1.106:6080/arcgis/rest/services/amanaTest/amanaTest/MapServer';

        // const sublayerTitles = [
        //   "طبقة البلدية",
        //   "طبقة استخدام الأرض",
        //   "طبقة المخططات",
        //   "طبقة الأراضي"
        // ];

        // let layer = new MapImageLayer({
        //   url: layerUrl,
        //   sublayers: [
        //     {
        //       id: 3,
        //       title: sublayerTitles[0]
        //     },
        //     {
        //       id: 2,
        //       title: sublayerTitles[1]
        //     },
        //     {
        //       id: 1,
        //       title: sublayerTitles[2]
        //     },
        //     {
        //       id: 0,
        //       title: sublayerTitles[3]
        //     }

        //   ]
        // });

        // layer.load().then(() => {
        //   this.mapService.map.layers.add(layer);
        // });
        this.mapService.configureMapLayer();
        //hold test
        reactiveUtils.when(
            () => this.mapService.mapView.stationary === true,
            () => {
                this.extentChangeHandler(this.mapService.mapView.extent);
            }
        );

        // layer List

        this.layerList = new LayerList({
            id: 'layerList',
            view: this.mapService.mapView,
            listItemCreatedFunction: async (event) => {
                const item = event.item;
                await item.layer.when();

                item.actionsSections = [
                    [
                        {
                            title: 'Increase opacity',
                            className: 'esri-icon-up',
                            id: 'increase-opacity' //'change-opacity'
                        },
                        {
                            title: 'Decrease opacity',
                            className: 'esri-icon-down',
                            id: 'decrease-opacity'
                        }
                    ]
                ];
                // Adds a slider for updating a group layer's opacity

                // if (item.children.length > 1 && item.parent) {

                // Create a Legend widget
                const legend = new Legend({
                    view: this.mapService.mapView,
                    layerInfos: [
                        {
                            layer: item.layer,
                            title: item.layer.title
                        }
                    ]
                });

                const slider = new Slider({
                    min: 0,
                    max: 1,
                    precision: 2,
                    values: [1],
                    visibleElements: {
                        labels: true,
                        rangeLabels: true
                    }
                });

                item.panel = {
                    content: [legend, slider],
                    className: 'esri-icon-sliders-horizontal',
                    title: 'Change layer opacity'
                };

                slider.on('thumb-drag', (event) => {
                    const { value } = event;
                    item.layer.opacity = value;
                });
                // }
            }
        });

        this.layerList.on('trigger-action', (event) => {
            const id = event.action.id;
            const layr = event.item.layer;
            // const visibleLayer =layr.visible;

            if (id === 'increase-opacity') {
                // if the increase-opacity action is triggered, then
                // increase the opacity of the GroupLayer by 0.25

                if (layr.opacity < 1) {
                    layr.opacity += 0.25;
                }
            } else if (id === 'decrease-opacity') {
                // if the decrease-opacity action is triggered, then
                // decrease the opacity of the GroupLayer by 0.25

                if (layr.opacity > 0) {
                    layr.opacity -= 0.25;
                }
            }
        });
        // layer list
        this.mapService.mapView.ui.add(this.layerList, 'top-left');

        const streetsLayer = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/0', //this.mapService.streetsLayer
            title: ' طبقة الشوارع '
        });

        const parcelLayer = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/2', //this.mapService.corrParcelLayer
            title: ' طبقة الأراضي المصححة '
        });
        const PARBoundryLayerNew = new FeatureLayer({
            url: 'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5', //this.mapService.finalPlansLayer
            title: ' طبقة المخططات '
            // visible: false
        });

        // const zonesLayer = new FeatureLayer({
        //   url: "https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/6",
        //   // title: " طبقة النطاقات ",
        //   // visible: false
        // });

        // const belediyeLayer = new FeatureLayer({
        //   url: "https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/7",
        //   // title: " طبقة البلدية ",
        //   // visible: false
        // });

        let parcelLayerSource = new LayerSearchSource({
            layer: parcelLayer,
            searchFields: ['PARCEL_ID'], // رقم مميز قطعة الأرض
            displayField: 'SUBDIVISIONPLANNAME_AR', // الاسم بالعربية
            // exactMatch: false,
            outFields: ['*'],
            name: 'قطع الأراضي',
            placeholder: 'example: 1-299087',
            popupTemplate: {
                // autocasts as new PopupTemplate()
                title: ' رقم القطعة: {PARCEL_ID} </br> إسم المخطط:{SUBDIVISIONPLANNAME_AR} </br> رقم المخطط: ({SUBDIVISIONPLAN_ID})',
                overwriteActions: true
            }
        });
        // console.log(parcelLayerSource);
        let PARBoundryNewLayerSource = new LayerSearchSource({
            layer: PARBoundryLayerNew,
            searchFields: ['SUBDIVISIONPLAN_ID', 'SUBDIVISIONNAME_AR'],
            displayField: 'SUBDIVISIONPLAN_ID',
            suggestionTemplate:
                '{SUBDIVISIONPLAN_ID}, PLAN NAME: N{SUBDIVISIONNAME_AR}',
            // exactMatch: false,
            outFields: [
                'parcel_plane',
                'Correction_Parcel',
                'MadinahAerialPhotography_zone',
                'Comparison',
                'Plan_Correct',
                'Balady_2',
                'F3D',
                'Zoon_Code',
                'BELEDIYE'
            ],
            placeholder: 'example: 875\\ت\\1420 or سليمان حامد الاحمدى ',
            name: 'المخططات',
            popupTemplate: {
                // autocasts as new PopupTemplate()
                title: ' إسم المخطط: {SUBDIVISIONNAME_AR} </br> رقم المخطط: {SUBDIVISIONPLAN_ID}',
                overwriteActions: true
            }
            // zoomScale: 500000,
        });
        PARBoundryLayerNew['defaultQueryFeatures'] =
            PARBoundryLayerNew.queryFeatures;
        PARBoundryLayerNew.queryFeatures = function (
            query: __esri.QueryProperties
        ) {
            if (query && typeof query.where == 'string') {
                query.where = query.where.replace(/ LIKE '/g, " LIKE N'%");
            }
            // return PARBoundryLayerNew.get<Function>(
            //     'defaultQueryFeatures'
            // ).apply(this, arguments);
            return PARBoundryLayerNew['defaultQueryFeatures']?.apply(
                this,
                arguments
            );
        };

        let search = new Search({
            view: this.mapService.mapView,
            allPlaceholder: 'البحث في جميع الطبقات',
            includeDefaultSources: false,
            container: 'searchWidget',
            sources: [parcelLayerSource, PARBoundryNewLayerSource] //, PARBoundryLayerSource
        });
        // // hide search
        // this.mapService.mapView.ui.add(search, 'manual');

        //identify

        // executeIdentify() is called each time the view is clicked
        this.mapService.mapView.on('click', (event) => {
            this.executeIdentify(event);
        });

        //-------------------------

        // const url =
        //     'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5'; //this.mapService.finalPlansLayer
        const fields = [
            'parcel_plane',
            'correction_Parcel',
            'MadinahAerialPhotography_zone',
            'Plan_Correct',
            'Zoon_Code',
            'Comparison',
            'Balady_2',
            'F3D',
            'BELEDIYE'
        ];

        this.createAttributeTable(this.url, fields);
    }



    createAttributeTable(url: string, fields: string[]) {
        const container =
            this.elementRef.nativeElement.querySelector('.attributeContent');

        const layer = new FeatureLayer({
            url: url,
            outFields: fields
        });

        // Container for temporary feature highlights based on table and view interaction.
        const highlightHandles = new Handles();

        this.mapService.mapView.when(() => {
            const featureTable = new FeatureTable({
                returnGeometryEnabled: true,
                view: this.mapService.mapView, // Replace with your MapView instance
                layer: layer,
                container: container,
                // actionColumnConfig: {
                //     label: "Zoom to feature",
                //     icon: "zoom-to-object",
                //     callback: ({ feature }) => this.mapService.mapView.goTo(feature)
                //   },
                visibleElements: {
                    // Autocast to VisibleElements
                    menuItems: {
                        clearSelection: true,
                        refreshData: true,
                        toggleColumns: true,
                        selectedRecordsShowAllToggle: true,
                        zoomToSelection: true
                    }
                },
                editingEnabled: true,
                tableTemplate: {
                    // autocast to TableTemplate
                    columnTemplates: [
                        // takes an array of GroupColumnTemplate and FieldColumnTemplate
                        // { // autocast to GroupColumnTemplate
                        // type: "group",
                        // label: "Parcel details",
                        // columnTemplates: [
                        {
                            type: 'field',
                            fieldName: 'OBJECTID',
                            label: 'OBJECTID'
                        },
                        {
                            type: 'field',
                            fieldName: 'parcel_plane',
                            label: 'رسم المخطط'
                        },
                        {
                            type: 'field',
                            fieldName: 'correction_Parcel',
                            label: 'تصحيح الأراضي'
                        },
                        {
                            type: 'field',
                            fieldName: 'MadinahAerialPhotography_zone',
                            label: 'مرحلة العمل بالتصوير الجوي'
                        },
                        {
                            type: 'field',
                            fieldName: 'Plan_Correct',
                            label: 'مرحلة تصحيح المخطط'
                        },
                        {
                            type: 'field',
                            fieldName: 'Zoon_Code',
                            label: 'تقسيم النطاقات'
                        },
                        {
                            type: 'field',
                            fieldName: 'Comparison',
                            label: 'المطـابقـة'
                        },
                        {
                            type: 'field',
                            fieldName: 'Balady_2',
                            label: 'بلدي_2'
                        },
                        {
                            type: 'field',
                            fieldName: 'F3D',
                            label: 'الرسم_ثلاثي_الأبعاد'
                        }
                    ]
                }
            });

            reactiveUtils.when(
                () => this.mapService.mapView.stationary,
                () => {
                    // Filter out and show only the visible features in the feature table.
                    featureTable.filterGeometry =
                        this.mapService.mapView.extent;
                },
                {
                    initial: true
                }
            );

            // Listen for the view's click event and access the associated graphic.

            this.mapService.mapView.on('immediate-click', async (event) => {
                const response = await this.mapService.mapView.hitTest(event);

                this.candidate = response.results.find((result) => {
                    // debugger;
                    // return( result.graphic && result.graphic.layer && result.graphic.layer === layer);
                });

                // Add the graphic's ObjectId into the collection of highlightIds.
                // Check that the featureTable.highlightIds collection
                // does not include an already highlighted feature.
                if (this.candidate) {
                    const objectId = this.candidate.graphic.getObjectId();

                    if (featureTable.highlightIds.includes(objectId)) {
                        // Remove feature from current selection if feature
                        // is already added to highlightIds collection
                        featureTable.highlightIds.remove(objectId);
                    } else {
                        // Add this feature to the featureTable highlightIds collection
                        featureTable.highlightIds.add(objectId);
                    }
                }
            });

            // Watch the featureTable's highlightIds.length property,
            // and get the count of highlighted features within
            // the table.

            reactiveUtils.watch(
                () => featureTable.highlightIds.length,
                (highlightIdsCount) => {
                    // Iterate through the filters within the table.
                    // If the active filter is "Show selection",
                    // changes made to highlightIds (adding/removing)
                    // are reflected.

                    featureTable.viewModel.activeFilters.forEach((filter) => {
                        if (filter.type === 'selection') {
                            // debugger;
                            // this.selectionIdCount = filter.objectIds.length; // the filtered selection's id count

                            // Check that the filter selection count is equal to the
                            // highlightIds collection count. If not, update filter selection.
                            if (this.selectionIdCount !== highlightIdsCount) {
                                featureTable.filterBySelection();
                            }
                        }
                    });
                }
            );
            // featureTable.view.when().then(() => {
            //     const viewModel = featureTable.view.viewModel;

            //     // Subscribe to row selection changes
            //     viewModel.on("selection-change", function(event) {
            //         const features = event.selectedFeatureIds;

            //         // Check if any features are selected
            //         if (features.length > 0) {
            //             // Perform your custom action here, e.g., zooming to a feature
            //             const feature = features[0];
            //             this.mapService.mapView.goTo(feature);
            //         }
            //     });
            // });
        });
    }

    // End Of ng After View Init //

    panToSubSearch() {
        // console.log(2222);
        // const  showSearch = document.querySelector(
        //     ".overlay-taslsoli"
        //   ) as HTMLElement;

        //   showSearch.classList.toggle("active");
        // this.showOverlayPopup = false;
        // this.layerPopup.classList.remove("active");
    }
    // Return to the main zoom of the map
    zoomToHome() {
        if (this.mapService.mapView) {
            this.mapService.mapView.goTo({
                center: [
                    this.environment.baseConfigs.defaultMapSettings.centerLon,
                    this.environment.baseConfigs.defaultMapSettings.centerLat
                ],
                zoom: this.environment.baseConfigs.defaultMapSettings.zoomLevel
            });
        }
    }

    zoomToNextExtent(): void {
        this.nextExtent = true;
        this.extentHistoryIndx++;
        if (this.extentHistoryIndx > this.extentHistory.length - 1) {
            this.extentHistoryIndx = this.extentHistory.length - 1;
        }
        this.mapService.mapView.goTo(
            this.extentHistory[this.extentHistoryIndx].currentExtent
        );
    }

    zoomToPreviousExtent(): void {
        if (this.extentHistory[this.extentHistoryIndx].preExtent) {
            this.prevExtent = true;
            this.mapService.mapView.goTo(
                this.extentHistory[this.extentHistoryIndx].preExtent
            );
            this.extentHistoryIndx--;
        }
    }

    extentChangeHandler(evt) {
        if (this.prevExtent || this.nextExtent) {
            this.currentExtent = evt;
        } else {
            this.preExtent = this.currentExtent;
            this.currentExtent = evt;
            this.extentHistory.push({
                preExtent: this.preExtent,
                currentExtent: this.currentExtent
            });
            this.extentHistoryIndx = this.extentHistory.length - 1;
        }
        this.prevExtent = this.nextExtent = false;
        // this.extentHistoryChange();
    }

    // extentHistoryChange() {
    //   if (this.extentHistory.length === 0 || this.extentHistoryIndx === 0) {
    //     this.l_zoomPrevBtn.classList.add('esri-disabled');
    //   } else {
    //     this.l_zoomPrevBtn.classList.remove('esri-disabled');
    //   }
    //   if (this.extentHistory.length === 0 || this.extentHistoryIndx === this.extentHistory.length - 1) {
    //     this.l_zoomNextBtn.classList.add('esri-disabled');
    //   }else {
    //     this.l_zoomNextBtn.classList.remove('esri-disabled');
    //   }
    // }

    ngOnDestroy(): void {
        if (this.mapService.mapView) {
            this.mapService.mapView.destroy();
            // this.unsubscribeFromSearchService();
        }
    }
    executeIdentify(event) {
        if (this.measureFlag == false) {
            if (true) {
                // console.log(event);
                // console.log(this);

                // Set the parameters for the identify
                let params = new IdentifyParameters();
                params.tolerance = 3;
                params.layerIds = [2, 4, 5]; //[0, 1, 2, 4, 5, 6, 7]; //
                params.layerOption = 'all';
                params.width = this.mapService.mapView.width;
                params.height = this.mapService.mapView.height;
                // Set the geometry to the location of the view click
                params.geometry = event.mapPoint;
                params.mapExtent = this.mapService.mapView.extent;

                identify
                    .identify(this.mapService.layerUrl, params)
                    .then(function (response) {
                        const results = response.results;
                        const subStatus = {
                            1: 'تم التصحيح',
                            2: 'جاري العمل',
                            3: 'ضبط الجودة',
                            4: 'مخالف للمعايير',
                            5: 'تم الاعتماد',
                            6: 'لم يتم العمل'
                        };
                        return results.map(function (result) {
                            let feature = result.feature;
                            let layerName = result.layerName;
                            // Correctly assign the status value based on the domain ID
                            feature.attributes.subdivision_status =
                                subStatus[feature.attributes.subdivision_status];
                            feature.attributes.layerName = layerName;
                            // console.log('layerName=' + layerName);
                            // console.log(feature);
                            if (
                                layerName ===
                                'PlanCorrectionDB.DBO.CorrectedParcels'
                            ) {
                                feature.popupTemplate = {
                                    // autocasts as new PopupTemplate()
                                    title: 'طبقة قطع الأراضي',
                                    content: [
                                        {
                                            type: 'fields',
                                            fieldInfos: [
                                                {
                                                    fieldName:
                                                        'SUBDIVISIONPLANNAME_AR',
                                                    label: 'اسم المخطط التقسيمي'
                                                },
                                                {
                                                    fieldName: 'SUBDIVISIONPLAN_ID',
                                                    label: 'رقم مميز المخطط التقسيمي'
                                                },
                                                {
                                                    fieldName: 'PARCEL_ID',
                                                    label: 'رقم مميز قطعة الأرض'
                                                }
                                            ]
                                        }
                                    ]
                                };
                            } else if (layerName === 'STREET_Amana') {
                                feature.popupTemplate = {
                                    // autocasts as new PopupTemplate()
                                    title: 'طبقة الشوارع',
                                    content: [
                                        {
                                            type: 'fields',
                                            fieldInfos: [
                                                {
                                                    fieldName: 'NAME_ARABI',
                                                    label: 'الإسم'
                                                },
                                                {
                                                    fieldName: 'NO',
                                                    label: 'الرقم'
                                                }
                                            ]
                                        }
                                    ]
                                };
                            } else if (layerName === 'planCorrection.DBO.Almadinah_zone_RER') {
                                feature.popupTemplate = {
                                    // autocasts as new PopupTemplate()
                                    title: 'طبقة مناطق الإعلان',
                                    content: [
                                        {
                                            type: 'fields',
                                            fieldInfos: [
                                                {
                                                    fieldName: 'REA_NAME_A',
                                                    label: 'الإسم بالعربي'
                                                },
                                                {
                                                    fieldName: 'REA_NAME_E',
                                                    label: 'الإسم بالإنجليزي'
                                                },
                                                {
                                                    fieldName: 'AREA_SQM',
                                                    label: 'المساحة بالمتر المربع'
                                                },
                                                {
                                                    fieldName: 'DESCRIPTIO',
                                                    label: 'الوصف'
                                                }
                                            ]
                                        }
                                    ]
                                };
                            } else if (
                                layerName === 'PlanCorrectionDB.DBO.Finall_plans'
                            ) {
                                feature.popupTemplate = {
                                    // autocasts as new PopupTemplate()
                                    title: 'طبقة المخططات', //"{LABEL_LOCAL}",

                                    content: [
                                        {
                                            type: 'fields',
                                            fieldInfos: [
                                                {
                                                    fieldName: 'SUBDIVISIONNAME_AR',
                                                    label: 'اسم المخطط'
                                                },
                                                {
                                                    fieldName: 'SUBDIVISIONPLAN_ID',
                                                    label: 'رقم مميز المخطط'
                                                },
                                                {
                                                    fieldName: 'AMANAPLANTYPE',
                                                    label: 'نوع المخطط'
                                                },
                                                {
                                                    fieldName: 'subdivision_status',
                                                    label: 'حالة المخطط'
                                                },
                                                {
                                                    fieldName: 'NOOFPARCEL_1',
                                                    label: 'عدد قطع الأراضي'
                                                },
                                                {
                                                    fieldName: 'Aeria_photography',
                                                    label: 'تقسيم مناطق التصوير الجوي'
                                                },
                                                {
                                                    fieldName: 'Plan_Correct',
                                                    label: 'مرحلة تصحيح المخطط'
                                                },
                                                {
                                                    fieldName: 'Neigh_region',
                                                    label: 'اسم الحي'
                                                },
                                                {
                                                    fieldName: 'parcel_plane',
                                                    label: 'رسم المخطط'
                                                },
                                                {
                                                    fieldName: 'Zoon_Code',
                                                    label: 'تقسيم النطاقات'
                                                },
                                                {
                                                    fieldName: 'Parcel_Area_1',
                                                    label: 'مساحة القطع'
                                                },
                                                {
                                                    fieldName: 'Comparison',
                                                    label: 'المطـابقـة'
                                                }
                                            ]
                                        }
                                    ]
                                };
                            } else if (
                                layerName === 'PlanCorrectionDB.DBO.Neigh_region'
                            ) {
                                feature.popupTemplate = {
                                    // autocasts as new PopupTemplate()
                                    title: 'طبقة الأحياء',
                                    content: [
                                        {
                                            type: 'fields',
                                            fieldInfos: [
                                                {
                                                    fieldName: 'NEIGH_NAME',
                                                    label: 'اسم الحي'
                                                },
                                                {
                                                    fieldName: 'DISTRICT_N',
                                                    label: 'المنطقة'
                                                },
                                                {
                                                    fieldName: 'BELEDIYE',
                                                    label: 'البلدية'
                                                },
                                                {
                                                    fieldName: 'DIST_CODE',
                                                    label: 'كود المنطقة'
                                                },
                                                {
                                                    fieldName: 'NEIGH_CODE',
                                                    label: 'كود الحي'
                                                },
                                                {
                                                    fieldName: 'BEL_CODE',
                                                    label: 'كود البلدية'
                                                },
                                                {
                                                    fieldName: 'NEIGH_AREA',
                                                    label: 'مساحة الحي'
                                                },
                                                {
                                                    fieldName: 'Plans',
                                                    label: 'المعدد المخططاتطـابقـة'
                                                }
                                            ]
                                        }
                                    ]
                                };
                            } else if (layerName === 'PlanCorrectionDB.DBO.zoon') {
                                feature.popupTemplate = {
                                    // autocasts as new PopupTemplate()
                                    title: 'طبقة النطاقات',
                                    content: [
                                        {
                                            type: 'fields',
                                            fieldInfos: [
                                                {
                                                    fieldName: 'Priority',
                                                    label: 'الأولوية'
                                                },
                                                {
                                                    fieldName: 'تقسيم_المناطق_1',
                                                    label: 'كود النطاق'
                                                }
                                            ]
                                        }
                                    ]
                                };
                            } else if (
                                layerName === 'PlanCorrectionDB.DBO.BELEDIYE_region'
                            ) {
                                feature.popupTemplate = {
                                    // autocasts as new PopupTemplate()
                                    title: 'طبقة البلدية',
                                    content: [
                                        {
                                            type: 'fields',
                                            fieldInfos: [
                                                {
                                                    fieldName: 'BELEDIYE',
                                                    label: 'اسم البلدية'
                                                },
                                                {
                                                    fieldName: 'BEL_CODE',
                                                    label: 'كود البلدية'
                                                },
                                                {
                                                    fieldName: 'BEL_AREA',
                                                    label: 'مساحة البلدية'
                                                }
                                            ]
                                        }
                                    ]
                                };
                            } else if (
                                layerName ===
                                'PlanCorrectionDB.DBO.MadinahAerialPhotography_zone'
                            ) {
                                feature.popupTemplate = {
                                    // autocasts as new PopupTemplate()
                                    title: 'طبقة نطاق التصوير الجوي',

                                    content: [
                                        {
                                            type: 'fields',
                                            fieldInfos: [
                                                {
                                                    fieldName: 'NAME',
                                                    label: 'الإسم'
                                                },
                                                {
                                                    fieldName: 'Sub_BlockI',
                                                    label: 'Sub_BlockI'
                                                },
                                                {
                                                    fieldName: 'AREA_PHOTOGRAPHY',
                                                    label: 'AREA_PHOTOGRAPHY'
                                                }
                                            ]
                                        }
                                    ]
                                };
                            }
                            return feature;
                        });
                    })
                    .then((response) => {
                        // Send the array of features to showPopup()
                        this.showPopup(response, event);
                    });

                // Shows the results of the identify in a popup once the promise is resolved
                //------------------------------main before test
            }
        }
    }
    showPopup(response, event) {
        if (response.length > 0) {
            this.mapService.mapView.openPopup({
                features: response,
                location: event.mapPoint
            });
        }
        // document.getElementById("feature.attributes.mapView").style.cursor = "auto";
    }

    poenAndHideOverliyPopup() { }
    // ===========================================
    // Show Overlay Popup
    // ===========================================
    showOverlayPopup: boolean = false;
    poenDetailsPopup() {
        this.showOverlayPopup = !this.showOverlayPopup;
        this.layerPopup.classList.remove('active');
        this.switchBetweenMap.classList.remove('active');
        this.ShowSearch = false;
        this.ShowTable = false;
    }

    // ----------------------------------
    switchBetweenMap;
    openSwitchMapPopup() {
        this.switchBetweenMap = document.querySelector(
            '.esri-widget.esri-basemap-toggle.esri-widget'
        ) as HTMLElement;
        this.switchBetweenMap.classList.toggle('active');
        this.showOverlayPopup = false;
        this.layerPopup.classList.remove('active');
        this.ShowSearch = false;
        this.ShowTable = false;
    }
    // -----------------------------------
    layerPopup;
    openLayerPopup() {
        this.layerPopup = document.querySelector(
            '.esri-component.esri-layer-list.esri-widget.esri-widget--panel'
        ) as HTMLElement;
        this.layerPopup.classList.toggle('active');
        this.switchBetweenMap?.classList.remove('active');
        this.showOverlayPopup = false;
        this.ShowSearch = false;
        this.ShowTable = false;
    }
    // -----------------------------------
    tasalsoliPopup;
    openTasalsoliPopup() {
        this.tasalsoliPopup = document.querySelector(
            '.overlay-taslsoli'
        ) as HTMLElement;
        this.tasalsoliPopup.classList.toggle('active');

        // this.switchBetweenMap.classList.remove("active");
        // this.showOverlayPopup = false;
    }

    fn(e) {
        e.preventDefault();
    }
    // =========================================================
    // NG ONINIT
    // =========================================================

    public planFieldNames: any[];
    selectionIdCount = 0; // The filtered selection id count
    candidate; // The graphic accessed via the view.click event
    selectedBaladeya: string = '';
    selectedZoneCode: string = '';
    zoneLegendName: string = '';
    baladeyaLegendName: string = '';
    parcel: any;
    plan: any;
    neigh: any;
    baladeya: any;


    async ngOnInit() {
        // debugger;

        // console.log(this.activeView)
        await this.queryBaladeyaNames();
        this.queryPlanCases();
        await this.createSumAndCount(this.selectedBaladyaArr);
        // this.RERcount(this.selectedBaladyaArr);
        await this.comparisonStatus(this.selectedBaladyaArr);
        await this.planStatus(this.selectedBaladyaArr);
        await this.baladyPercentage(this.selectedBaladyaArr);
        await this.madinahPhotographyPercent(this.selectedBaladyaArr);
        await this.baladyaStatus();
        await this.projectTotalInjaz();

        // setTimeout(function () {
        if (this?.madinahInfoPie)
            this.madinahInfoPie.percentage = this.madinahPercent;
        if (this?.baladyInfoPie) {
            this.baladyInfoPie.updateChartData(this.baladyPercent);
            this.baladyinjaz = this.baladyPercent
        }
        if (this?.doneInfoPie)
            this.doneInfoPie.percentage = this.totalEnjaz;
        this?.getFakeData();
        // }, 1500);

        // let that = this;





        this.mapService.load().subscribe((data) => {
            // debugger;

            this.mapService.setConfigData(data);

            // console.log (this.deliveredRERcount);

            // console.log(this.mapService.arcserverurl);
            // console.log(this.mapService.amanaMapservice);
            // console.log(this.mapService.amanaFeatureService);
            // console.log(this.mapService.MadinahAerialPhotography);
            // console.log(this.mapService.CorrectedParcels);
            // console.log(this.mapService.MP_TANZEEM);
            // console.log(this.mapService.Finall_plans);
            // console.log(this.mapService.Neigh_region);
            // console.log(this.mapService.zoon);
            // console.log(this.mapService.BELEDIYE);
            // console.log(
            //     this.mapService.streetsLayer,
            //     this.mapService.madinahAphotoLayer,
            //     this.mapService.corrParcelLayer,
            //     this.mapService.mpTanzeemLayer,
            //     this.mapService.finalPlansLayer,
            //     this.mapService.neighRegLayer,
            //     this.mapService.zoonLayer,
            //     this.mapService.baladiyaLayer)
        });
        // debugger;
        this.url =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5'; //`${this.mapService.finalPlansLayer}`

        this.layerPln = new FeatureLayer({
            url: this.url
        });


        this.zoneLegendName = 'جميع النطاقات';
        this.baladeyaLegendName = 'جميع البلديات';

        this.mainPlanFields = ['Zoon_Code', 'BELEDIYE'];
        this.planFieldNames = [
            'parcel_plane',
            'Correction_Parcel',
            'MadinahAerialPhotography_zone',
            'Comparison',
            'Plan_Correct',
            'Balady_2',
            'F3D'
        ];
        //const url ='https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5'; //this.mapService.finalPlansLayer

        this.layer = new FeatureLayer({
            url: this.url
        });
        // //removed into mapService.load

        // // this.createSumAndCount();
        // // this.RERcount();
        // // console.log (this.deliveredRERcount);

        // let mainIndx = 0;
        // let indx = 2;
        // this.mainPlanFields.forEach((field) => {
        //     this.mainQuery = this.layer.createQuery();
        //     const statisticDefinitions = new StatisticDefinition({
        //         onStatisticField: 'objectid',
        //         outStatisticFieldName: field + '_C',
        //         statisticType: 'count'
        //     });

        //     this.mainQuery.outStatistics = [statisticDefinitions];
        //     this.mainQuery.returnGeometry = false;
        //     this.mainQuery.groupByFieldsForStatistics = [field];
        //     let that = this;
        //     this.layer
        //         .queryFeatures(this.mainQuery)
        //         .then(function (result) {
        //             const features =
        //                 result && result.features ? result.features : [];
        //             mainIndx++;

        //             if (features) {
        //                 that.createMainCharts(result, mainIndx);
        //                 // console.log(features[0].attributes);
        //             } else {
        //                 console.error('No features found.');
        //             }
        //         })
        //         .catch(function (error) {
        //             console.error('Error fetching features:', error);
        //         });
        // });

        // // if (!this.selectedBaladeya && !this.selectedZoneCode){
        // this.planFieldNames.forEach((field) => {
        //     //debugger;
        //     this.query = this.layer.createQuery();

        //     const statisticDefinitions = new StatisticDefinition({
        //         onStatisticField: 'objectid',
        //         outStatisticFieldName: field + '_C',
        //         statisticType: 'count'
        //     });

        //     this.query.outStatistics = [statisticDefinitions];
        //     this.query.returnGeometry = false;
        //     //query.where = '1=1';
        //     this.query.groupByFieldsForStatistics = [field];

        //     let that = this;
        //     this.layer
        //         .queryFeatures(this.query)
        //         .then(function (result) {
        //             //  debugger;
        //             console.log(result);
        //             let stats = result.features[0].attributes;
        //             console.log('output stats:', stats);
        //             const features =
        //                 result && result.features ? result.features : [];

        //             indx++;
        //             if (features) {
        //                 that.createCharts(result, indx);

        //                 console.log(features[0].attributes);
        //             } else {
        //                 console.error('No features found.');
        //             }
        //         })
        //         .catch(function (error) {
        //             console.error('Error fetching features:', error);
        //         });
        // });
    }
    // takeScreenshot() {
    //     const self = this;
    //     // Get the current viewport dimensions
    //     const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    //     const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    //     this.mapService.mapView.takeScreenshot({
    //         width: width,
    //         height: height
    //     }).then(function(screenshot) {
    //         self.screenshotImgSrc = screenshot.dataUrl;
    //     });
    // }

    // takeScreenshot() {
    //     const self = this;

    //     // Get the current viewport dimensions
    //     const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    //     const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    //     // Create a temporary canvas element
    //     const canvas = document.createElement('canvas');
    //     canvas.width = width;
    //     canvas.height = height;

    //     // Get the current page contents
    //     const ctx = canvas.getContext('2d');

    //     // Capture the entire page
    //     ctx.drawImage(document.documentElement, 0, 0);

    //     // Convert the canvas to a data URL
    //     const screenshotDataUrl = canvas.toDataURL('image/png');

    //     // Clean up the temporary canvas
    //     canvas.remove();

    //     // Update the screenshot image source
    //     self.screenshotImgSrc = screenshotDataUrl;
    //   }





    measure() {
        const measurement = new Measurement({
            view: this.mapService.mapView
        });

        this.mapService.mapView.ui.add(measurement, 'bottom-left');

        // Handle button clicks for distance and area measurements
        document.getElementById('distance').addEventListener('click', () => {
            this.measureFlag = true;
            measurement.activeTool = 'distance';
        });

        document.getElementById('area').addEventListener('click', () => {
            this.measureFlag = true;
            measurement.activeTool = 'area';
        });
        document.getElementById('clear').addEventListener('click', () => {
            measurement.clear();
            this.measureFlag = false;
        })
    }
    defQuery(list) {
        // debugger;
        let whereClause = '';
        if (list.length > 0) {
            let arr2 = list.map((x) => "N'" + x + "'");
            const array = arr2.join(',');
            whereClause += ` AND BELEDIYE IN (` + array + `)`;
            // console.log(arr2);
            // console.log(array);
            // console.log(whereClause);
        }

        return whereClause;
    }
    async filterSelectedBaladya() {

        this.selectedBaladyaArr = [];

        this.parcel = this.mapService.mapImgLayer.findSublayerById(2);
        this.plan = this.mapService.mapImgLayer.findSublayerById(5);
        this.neigh = this.mapService.mapImgLayer.findSublayerById(6);
        this.baladeya = this.mapService.mapImgLayer.findSublayerById(8);

        let graphics = [];
        this.mapService.mapView.graphics.removeAll();
        for (const x in this.baladyasList) {
            if (this.baladyasList[x].isChecked == true) {
                // debugger;
                this.flagg = true;
                this.selectedBaladyaArr.push(this.baladyasList[x].lable);
                // console.log(this.baladyasList[x]);

                const bFilter = this.defQuery(this.selectedBaladyaArr);
                this.baladeya.definitionExpression = `1=1${bFilter}`; //`BELEDIYE= N'${this.baladyasList[x].lable}'`;
                this.plan.definitionExpression = `1=1${bFilter}`;
                this.neigh.definitionExpression = `1=1${bFilter}`;
                const baladeyaQuery = {
                    outFields: ['shape'],
                    where: `BELEDIYE = N'${this.baladyasList[x].lable}'` //`1=1${bFilter}`//
                };
                let response = await this.mapService.belediyeLayer.queryFeatures(baladeyaQuery);
                // this.mapService.belediyeLayer.queryFeatures(baladeyaQuery).then(function (response) {
                // debugger;
                const newSymbol = {
                    type: 'simple-fill',
                    color: [0, 255, 255, 0.1],
                    outline: {
                        color: [255, 255, 255],
                        width: 1
                    }
                };
                // Create a new graphic for each feature in the response
                let g = response.features.map((feature) => {
                    return graphics.push(new Graphic({
                        geometry: feature.geometry,
                        symbol: newSymbol
                    })
                    )
                });


                // });
            }
            // else if (this.baladyasList[x].isChecked == false) {
            //     this.mapService.mapView.graphics.removeAll();
            // }
        }
        // this.mapService.mapView.graphics.removeAll();
        // Add the graphics to the map
        graphics.forEach((graphic) => {
            // console.log(that);
            this.mapService.mapView.graphics.add(
                graphic
            );
        });

        // Zoom to the first graphic
        if (graphics.length > 0) {
            // console.log(graphics[0]);
            this.mapService.mapView.goTo(graphics);
        } else {
            this.zoomToHome();
        }
        if (!this.flagg) {
            this.baladeya.definitionExpression = '';
            this.plan.definitionExpression = '';
            this.neigh.definitionExpression = '';
        }

        await this.createSumAndCount(this.selectedBaladyaArr);
        // this.RERcount(this.selectedBaladyaArr);
        await this.comparisonStatus(this.selectedBaladyaArr);
        await this.planStatus(this.selectedBaladyaArr);
        await this.baladyPercentage(this.selectedBaladyaArr);
        await this.madinahPhotographyPercent(this.selectedBaladyaArr);

        // setTimeout(function () {
        // debugger;
        if (this?.madinahInfoPie)
            this.madinahInfoPie.percentage = this.madinahPercent;
        if (this?.baladyInfoPie)
            this.baladyInfoPie.updateChartData(this.baladyPercent);
        if (this?.doneInfoPie)
            this.doneInfoPie.percentage = this.totalEnjaz;
        this?.getFakeData();
        // }, 2000);

    }
    async baladyaStatus() {
        // let statusQuery= new Query();
        // statusQuery.where = "subdivision_status=N''"
        const baladyaCounts = {
            1: 0,
            7: 0,
            11: 0,
            12: 0,
            14: 0
        };

        const statisticDefinitions = [
            new StatisticDefinition({
                onStatisticField: 'BEL_CODE',
                outStatisticFieldName: 'BEL_CODE_1',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'BEL_CODE',
                outStatisticFieldName: 'BEL_CODE_7',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'BEL_CODE',
                outStatisticFieldName: 'BEL_CODE_11',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'BEL_CODE',
                outStatisticFieldName: 'BEL_CODE_12',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'BEL_CODE',
                outStatisticFieldName: 'BEL_CODE_14',
                statisticType: 'count'
            })
        ];

        let indx = 0;
        let arr = [];
        let planbaladyacounts = 0;
        for (const i in baladyaCounts) {
            // for(let x=1; x<=5; x++){
            const query = new Query();
            // if (list){
            //     let q= this.defQuery(list);
            //     console.log(q);
            //     query.where = `BEL_CODE = ${i}${q}`;
            //     }else{  query.where = `BEL_CODE = ${i}`;}

            query.where = `BEL_CODE = ${i}`;
            query.outFields = ['BEL_CODE'];
            query.groupByFieldsForStatistics = ['BEL_CODE'];
            query.outStatistics = [statisticDefinitions[indx]];
            indx++;
            // let that = this;
            let result = await this.layerPln.queryFeatures(query);
            // this.layerPln.queryFeatures(query).then(function (result) {
            // console.log(result);
            baladyaCounts[i] =
                result.features[0].attributes[`BEL_CODE_${i}`];
            // console.log(`Count for BEL_CODE = ${i}: ${baladyaCounts[i]}`);
            let obj: CenterFilterModel = {};
            planbaladyacounts += baladyaCounts[i];
            // console.log(planbaladyacounts);

            obj.id = `${i}`;
            obj['name'] = `${i}`;
            obj['lable'] = `${i}`;
            obj['lable2'] = '%';
            obj['info'] = baladyaCounts[i];
            if (obj.id == '14') {
                obj['name'] = 'قباء';
                obj['lable'] = obj['name'];
            } else if (obj.id == '11') {
                obj['name'] = 'العوالي';
                obj['lable'] = obj['name'];
            } else if (obj.id == '12') {
                obj['name'] = 'أحد';
                obj['lable'] = obj['name'];
            } else if (obj.id == '7') {
                obj['name'] = 'العقيق';
                obj['lable'] = obj['name'];
            } else if (obj.id == '1') {
                obj['name'] = 'الحرم';
                obj['lable'] = obj['name'];
            }
            arr.push(obj);
            // });
        }

        // setTimeout(() => {
        // debugger;
        this.baladyasList = arr.map((obj2) => {
            return {
                id: obj2['id'],
                name: obj2['name'],
                isChecked: false,
                info: obj2['info'],
                info2: 'مخطط',
                lable2:
                    '(' +
                    ((obj2['info'] / planbaladyacounts) * 100).toFixed(0) +
                    '%)',
                lable: obj2['lable']
            };
        });
        // }, 1000);
    }

    //إجمالي الانجاز للمشروع
    async projectTotalInjaz() {
        const statisticDefinitions = new StatisticDefinition({
            onStatisticField: 'subdivision_status',
            outStatisticFieldName: 'subdivision_status_1',
            statisticType: 'count'
        });
        const query = new Query();
        query.where = `subdivision_status =1 OR subdivision_status =5`;
        query.outFields = ['subdivision_status'];
        query.outStatistics = [statisticDefinitions];
        let result = await this.layerPln.queryFeatures(query);
        // this.layerPln.queryFeatures(query).then((result) => {
        // debugger;

        // let that = this;
        const feature = result.features;
        if (feature.length > 0) {
            this.allInjaz = parseFloat(
                (
                    (feature[0].attributes.subdivision_status_1 /
                        this.PlansCount) *
                    100
                ).toFixed(1)
            );
        }
        // console.log(this.allInjaz);
        // })
        // .catch((err) => {
        //     // debugger;

        //     console.log(err);
        // });
    }

    async planStatus(list) {
        // let statusQuery= new Query();
        // statusQuery.where = "subdivision_status=N''"
        const statusCounts = {
            // 1: 0,
            // 2: 0,
            // 3: 0,
            // 4: 0,
            // 5: 0,
            // 6: 0,
        };

        const statisticDefinitions = [
            new StatisticDefinition({
                onStatisticField: 'subdivision_status',
                outStatisticFieldName: 'subdivision_status_1',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'subdivision_status',
                outStatisticFieldName: 'subdivision_status_2',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'subdivision_status',
                outStatisticFieldName: 'subdivision_status_3',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'subdivision_status',
                outStatisticFieldName: 'subdivision_status_4',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'subdivision_status',
                outStatisticFieldName: 'subdivision_status_5',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'subdivision_status',
                outStatisticFieldName: 'subdivision_status_6',
                statisticType: 'count'
            })
        ];

        for (let i = 1; i <= 6; i++) {
            const query = new Query();
            if (list) {
                let q = this.defQuery(list);
                // console.log(q);
                query.where = `subdivision_status = ${i}${q}`;
            } else {
                query.where = `subdivision_status = ${i}`;
            }

            query.outFields = ['subdivision_status'];
            query.outStatistics = [statisticDefinitions[i - 1]];
            // let that = this;
            let result = await this.layerPln.queryFeatures(query);
            // this.layerPln.queryFeatures(query).then(function (result) {
            // console.log(query.outStatistics)
            // debugger;
            statusCounts[i] =
                result.features[0].attributes[`subdivision_status_${i}`];
            // console.log(`Count for subdivision_status = ${i}: ${statusCounts[i]}`);
            if (i == 1) {
                this.correctedCount = statusCounts[1];
                // this.totalEnjaz = parseFloat(
                //     (
                //         (this.correctedCount / this.PlansCount) *
                //         100
                //     ).toFixed(1)
                // );
                this.correctedpercentage = parseFloat(
                    (
                        (this.correctedCount / this.PlansCount) *
                        100
                    ).toFixed(1)
                );
                // console.log(this.totalEnjaz);
            } else if (i == 2) {
                this.pendingCount = statusCounts[2];
                this.pendingPercentage = parseFloat(
                    (
                        (this.pendingCount / this.PlansCount) *
                        100
                    ).toFixed(1)
                );
            } else if (i == 3) {
                this.qualityControlCount = statusCounts[3];
                this.qualityControlPercentage = parseFloat(
                    (
                        (this.qualityControlCount / this.PlansCount) *
                        100
                    ).toFixed(1)
                );
            } else if (i == 4) {
                this.cancelledCount = statusCounts[4];
                this.cancelledPercentage = parseFloat(
                    (
                        (this.cancelledCount / this.PlansCount) *
                        100
                    ).toFixed(1)
                );
            } else if (i == 5) {
                this.planApprovalCount = statusCounts[5];
                this.planApprovalpercentage = parseFloat(
                    (
                        (this.planApprovalCount / this.PlansCount) *
                        100
                    ).toFixed(1)
                );
            } else if (i == 6) {
                this.notCorrectedCount = statusCounts[6];
                this.notCorrectedPercentage = parseFloat(
                    (
                        (this.notCorrectedCount / this.PlansCount) *
                        100
                    ).toFixed(1)
                );
            }
            // console.log(statusCounts);
            // })
            // .catch(function (err) {
            //     console.log(err);
            // });
        }
        this.correctedApprovedCount = this.correctedCount + this.planApprovalCount
        this.correctedApprovedPercent = parseFloat(
            (
                (this.correctedApprovedCount / this.PlansCount) *
                100
            ).toFixed(1)
        );
        this.totalEnjaz = parseFloat(
            (
                ((this.correctedCount + this.planApprovalCount) / this.PlansCount) *
                100
            ).toFixed(1)
        );
    }

    async comparisonStatus(list) {
        // let statusQuery= new Query();
        // statusQuery.where = "comparison_status=N''"
        const statusCounts = {
            // 1: 0,
            // 2: 0,
            // 3: 0,

        };

        const statisticDefinitions = [
            new StatisticDefinition({
                onStatisticField: 'comparison_status',
                outStatisticFieldName: 'comparison_status_1',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'comparison_status',
                outStatisticFieldName: 'comparison_status_2',
                statisticType: 'count'
            }),
            new StatisticDefinition({
                onStatisticField: 'comparison_status',
                outStatisticFieldName: 'comparison_status_3',
                statisticType: 'count'
            })

        ];

        for (let i = 1; i <= 3; i++) {
            const query = new Query();
            if (list) {
                let q = this.defQuery(list);
                // console.log(q);
                query.where = `comparison_status = ${i}${q}`;
            } else {
                query.where = `comparison_status = ${i}`;
            }

            query.outFields = ['comparison_status'];
            query.outStatistics = [statisticDefinitions[i - 1]];
            // let that = this;

            let result = await this.layerPln.queryFeatures(query);
            // this.layerPln.queryFeatures(query).then(function (result) {

            statusCounts[i] =
                result.features[0].attributes[`comparison_status_${i}`];
            // console.log(`Count for comparison_status = ${i}: ${statusCounts[i]}`);
            if (i == 1) {
                this.deliveredRERcount = statusCounts[1]
            } else if (i == 2) {
                this.advertised = statusCounts[2]

            } else if (i == 3) {

                this.AdInProgress = statusCounts[3]
            }
            // console.log(statusCounts);
            // })
            // .catch(function (err) {
            //     console.log(err);
            // });
        }
    }

    // RERcount(list) {
    //     let queryRER = new Query();
    //     if (list) {
    //         let q = this.defQuery(list);
    //         console.log(q);
    //         queryRER.where = `Comparison=N'RER تم التسليم لـ'${q}`;
    //     } else {
    //         queryRER.where = "Comparison=N'RER تم التسليم لـ'";
    //     }
    //     const statisticDefinitionsRER = new StatisticDefinition({
    //         onStatisticField: 'Comparison',
    //         outStatisticFieldName: 'RER_C',
    //         statisticType: 'count'
    //     });
    //     queryRER.outStatistics = [statisticDefinitionsRER];

    //     this.layerPln
    //         .queryFeatures(queryRER)
    //         .then((result) => {
    //             // debugger;

    //             let that = this;
    //             const feature = result.features;
    //             if (feature.length > 0) {
    //                 that.deliveredRERcount = feature[0].attributes.RER_C;
    //             }
    //             console.log(that.deliveredRERcount);
    //         })
    //         .catch((err) => {
    //             // debugger;

    //             console.log(err);
    //         });
    // }
    async createSumAndCount(list) {
        // debugger;
        // const url ='https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5'; //this.mapService.finalPlansLayer
        // const layerPln = new FeatureLayer({
        //     url: this.url
        // });

        let querySC = new Query();
        if (list) {
            let q = this.defQuery(list);
            // console.log(q);
            querySC.where = `1=1${q}`;
        } else {
            querySC.where = '1=1';
        }
        // querySC.where = '1=1';
        // querySC.outFields = ['*'];

        // For parcel area
        const statisticDefinitions1 = new StatisticDefinition({
            onStatisticField: 'Parcel_Area_1',
            outStatisticFieldName: 'Parcel_Area_C',
            statisticType: 'sum'
        });

        // For parcel count
        const statisticDefinitions2 = new StatisticDefinition({
            onStatisticField: 'Parcel_Count_1',
            outStatisticFieldName: 'Parcel_Count_C',
            statisticType: 'sum'
        });

        const statisticDefinitions3 = new StatisticDefinition({
            onStatisticField: 'objectid',
            outStatisticFieldName: 'objectid_C',
            statisticType: 'count'
        });

        querySC.outStatistics = [
            statisticDefinitions1,
            statisticDefinitions2,
            statisticDefinitions3
        ];

        // debugger;
        let result = await this.layerPln.queryFeatures(querySC);
        // this.layerPln.queryFeatures(querySC).then((result) => {
        // debugger;

        // let that = this;
        const feature = result.features;
        if (feature.length > 0) {
            this.parcelCountSum = feature[0].attributes.Parcel_Count_C;
            this.parcelAreaSum = parseFloat(
                (feature[0].attributes.Parcel_Area_C / 1000000).toFixed(
                    2
                )
            );
            this.PlansCount = feature[0].attributes.objectid_C;
        }
        // })
        // .catch((err) => {
        //     console.log(err);
        // });
    }

    async baladyPercentage(list) {
        let baladyPercntQuery = new Query();
        if (list) {
            let q = this.defQuery(list);
            // console.log(q);
            baladyPercntQuery.where = `Balady_2 IS NOT NULL${q}`;
        } else {
            baladyPercntQuery.where = 'Balady_2 IS NOT NULL';
        }
        // baladyPercntQuery.where = "Balady_2 IS NOT NULL";
        const baladyStatisticDefinitions = new StatisticDefinition({
            onStatisticField: 'objectid',
            outStatisticFieldName: 'baladyNotNull_C',
            statisticType: 'count'
        });
        baladyPercntQuery.outStatistics = [baladyStatisticDefinitions];

        let result = await this.layerPln.queryFeatures(baladyPercntQuery);
        // this.layerPln.queryFeatures(baladyPercntQuery).then((result) => {
        // debugger;

        // let that = this;
        const feature = result.features;
        if (feature.length > 0) {
            this.baladyPercent = parseFloat(
                (
                    (feature[0].attributes.baladyNotNull_C /
                        this.PlansCount) *
                    100
                ).toFixed(1)
            );
            // console.log(that.PlansCount)
        }
        // console.log(this.baladyPercent);
        // })
        // .catch((err) => {
        //     // debugger;

        //     console.log(err);
        // });
    }
    async madinahPhotographyPercent(list) {
        let madinaPercntQuery = new Query();
        if (list) {
            let q = this.defQuery(list);
            // console.log(q);
            madinaPercntQuery.where = `MadinahAerialPhotography_zone IS NOT NULL${q}`;
        } else {
            madinaPercntQuery.where =
                'MadinahAerialPhotography_zone IS NOT NULL';
        }
        // madinaPercntQuery.where = "MadinahAerialPhotography_zone IS NOT NULL";
        const madinahStatisticDefinitions = new StatisticDefinition({
            onStatisticField: 'objectid',
            outStatisticFieldName: 'madinahNotNull_C',
            statisticType: 'count'
        });

        madinaPercntQuery.outStatistics = [madinahStatisticDefinitions];

        let result = await this.layerPln.queryFeatures(madinaPercntQuery);
        // this.layerPln.queryFeatures(madinaPercntQuery).then((result) => {
        // debugger;

        // let that = this;
        const feature = result.features;
        if (feature.length > 0) {
            this.madinahPercent = parseFloat(
                (
                    (feature[0].attributes.madinahNotNull_C /
                        this.PlansCount) *
                    100
                ).toFixed(1)
            );
        }
        // console.log(this.madinahPercent);
        // })
        // .catch((err) => {
        //     // debugger;

        //     console.log(err);
        // });
    }

    createMainCharts(features: any, mainIndx) {
        features.fields.forEach((fieldName, index) => {
            // console.log(features.features.map((f) => f.attributes));

            if (index == 0) {
                const canvasId = `MyChart${mainIndx}`;
                const chartData = features.features.map((f) => f.attributes); //fieldCounts[fieldName];
                const chartTitle = fieldName.name;
                const legendLabels = features.features.map(
                    (f) => f.attributes[fieldName.name]
                ); //Object.keys(chartData);
                // alert(canvasId);
                this.createChart(
                    canvasId,
                    chartData,
                    chartTitle,
                    legendLabels,
                    fieldName
                ); //fieldName
            }
        });
    }

    createCharts(features: any, indx) {
        // console.log(features);
        features.fields.forEach((fieldName, index) => {
            if (index == 0) {
                const canvasId = `MyChart${indx}`;
                const chartData = features.features.map((f) => f.attributes); //fieldCounts[fieldName];
                const chartTitle = fieldName.name;
                const legendLabels = features.features.map(
                    (f) => f.attributes[fieldName.name]
                ); //Object.keys(chartData);
                // alert(canvasId);
                this.createChart(
                    canvasId,
                    chartData,
                    chartTitle,
                    legendLabels,
                    fieldName
                );
            }
        });
    }

    createChart(
        canvasId: string,
        chartData,
        chartTitle: string,
        legendLabels: string[],
        filterFieldName: string
    ) {
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        const that = this;
        if (!canvas) {
            console.error(`Canvas element with ID "${canvasId}" not found.`);
            return;
        }

        if (Object.keys(chartData).length === 0) {
            console.error(`No data available for chart "${canvasId}".`);
            return;
        }

        let nChart = new Chart(canvas, {
            type: chartTitle == 'Zoon_Code' ? 'bar' : 'doughnut',

            data: {
                labels: chartData.map((f) => f[chartTitle]), //) Object.keys(chartData), //labels: legendLabels,
                datasets: [
                    {
                        data: chartData.map((f) => f[chartTitle + '_C']), //Object.values(chartData),
                        label: chartTitle,
                        //  backgroundColor: [
                        //    'rgba(103, 58, 183, 0.6)',
                        //    'rgba(38, 166, 154, 0.6)',
                        //    'rgba(0, 77, 64, 0.6)',
                        //    'rgba(26, 35, 126, 0.6)',
                        //    'rgba(106, 27, 154, 0.6)',
                        //    'rgba(74, 20, 140, 0.6)'
                        //  ]
                        backgroundColor: [
                            '#0D7167',
                            '#CFE3E1',
                            '#347863',
                            '#679A8A',
                            '#6EAAA4'
                        ]
                    }
                ]
            },
            options: {
                responsive: true,

                plugins: {
                    title: {
                        display: true,
                        text: chartTitle,
                        color: '#0D7167',
                        font: { size: 12, weight: 600 }
                    },
                    legend: {
                        position: 'bottom',

                        labels: {
                            color: '#707070',
                            font: { size: 10 }
                        }
                    }
                    // legend: {
                    //   labels: {
                    //     boxWidth: 10,
                    //     padding: 15,
                    //     color: '#000',
                    //     font: {
                    //       family: 'Arial',
                    //       size: 16
                    //     }
                    //   }
                    // }
                },
                onClick(event, elements, chart) {
                    let selected = chart.tooltip.title[0];
                    let chartIndex = chart.id;
                    let selectedFilter;
                    if (chart.data.datasets[0].label == 'BELEDIYE') {
                        this.selectedBaladeya = selected;
                        selectedFilter = 'BELEDIYE';
                        // this.query.where = `BELEDIYE = '${selected}'`;
                        // this.newChart.update();
                    }
                    if (chart.data.datasets[0].label == 'Zoon_Code') {
                        this.selectedZoneCode = selected;
                        selectedFilter = 'Zoon_Code';
                    }
                    that.selectFeatures(selected, chartIndex, selectedFilter);

                    // console.log(canvas.id)
                    // console.log(this.chartLayer)
                    // console.log(chart.data.labels)
                    // console.log(elements)
                    // console.log(chart.config.options.plugins.title.text)
                    // console.log(selected);
                    // console.log(this.selectedBaladeya);
                }
            }
        });
        this.newChart[canvasId] = nChart;
    }

    selectFeatures(selectedValue, canvasID, filterFieldName) {
        const that = this;
        let planFieldName = this.planFieldNames[canvasID];
        let mainPlanField = this.mainPlanFields[canvasID];
        let selectedDomain = selectedValue;
        let selectedDomainCode;

        if (selectedDomain == 'قباء') {
            selectedDomainCode = 14;
        } else if (selectedDomain == 'العوالي') {
            selectedDomainCode = 11;
        } else if (selectedDomain == 'أحد') {
            selectedDomainCode = 12;
        } else if (selectedDomain == 'العقيق') {
            selectedDomainCode = 7;
        } else if (selectedDomain == 'الحرم') {
            selectedDomainCode = 1;
        }

        // console.log(selectedDomain);
        // console.log(filterFieldName);
        // console.log(canvasID);

        if (filterFieldName == 'BELEDIYE' || filterFieldName == 'Zoon_Code') {
            let indx1 = 2;
            this.planFieldNames.forEach((field) => {
                //debugger;
                let query1 = this.layer.createQuery();

                const statisticDefinitions1 = new StatisticDefinition({
                    onStatisticField: 'objectid',
                    outStatisticFieldName: field + '_C',
                    statisticType: 'count'
                });

                query1.outStatistics = [statisticDefinitions1];
                query1.returnGeometry = true;
                query1.outFields = ['*'];
                // debugger
                if (filterFieldName === 'BELEDIYE') {
                    this.baladeyaLegendName = selectedDomain;
                    this.zoneLegendName = 'جميع النطاقات';
                    // console.log(selectedDomainCode);
                    query1.where = `BEL_CODE = '${selectedDomainCode}'`;
                    //alert(query1.where);
                } else if (filterFieldName === 'Zoon_Code') {
                    this.zoneLegendName = selectedValue;
                    this.baladeyaLegendName = 'جميع البلديات';
                    query1.where = `Zoon_Code = '${selectedDomain}'`;
                }
                query1.groupByFieldsForStatistics = [field];

                let that = this;
                this.layer.queryFeatures(query1).then(function (result) {
                    //  debugger;
                    // console.log(result);

                    const newSymbol = {
                        type: 'simple-fill',
                        color: [77, 75, 202, 0.8],
                        outline: {
                            color: [255, 255, 255],
                            width: 1
                        }
                    };

                    // Create a new graphic for each feature in the response
                    const graphics = result.features.map((feature) => {
                        return new Graphic({
                            geometry: feature.geometry,
                            symbol: newSymbol
                        });
                    });

                    // Add the graphics to the map
                    graphics.forEach((graphic) => {
                        // console.log(graphic);
                        return that.mapService.mapView.graphics.add(
                            graphic
                        );
                    });
                    // console.log(graphics.length);
                    // Zoom to the first graphic
                    if (graphics.length > 0) {
                        // console.log(graphics[0]);
                        that.mapService.mapView.goTo(graphics);
                    }

                    const features =
                        result && result.features ? result.features : [];

                    indx1++;
                    // console.log(indx1);
                    if (features) {
                        // console.log(features);

                        // if(canvasID==0 || canvasID==1){

                        // console.log(that.newChart['MyChart' + indx1]);
                        that.newChart['MyChart' + indx1].destroy();

                        that.createCharts(result, indx1);
                        that.newChart['MyChart' + indx1].update();

                        // }
                    } else {
                        console.error('No features found.');
                    }
                })
                    .catch(function (error) {
                        console.error('Error fetching features:', error);
                    });
            });
        } else if (planFieldName || mainPlanField) {
            // Clear previous graphics
            this.mapService.mapView.graphics.removeAll();

            const planQuery = {
                outFields: ['shape'],
                where:
                    planFieldName +
                    "='" +
                    selectedValue +
                    "' OR " +
                    mainPlanField +
                    "='" +
                    selectedValue +
                    "'"
            };
            // console.log('planFieldName=', planFieldName);
            // console.log('mainPlanField=', mainPlanField);

            this.mapService.parBoundary
                .queryFeatures(planQuery)
                .then(function (response) {
                    const newSymbol = {
                        type: 'simple-fill',
                        color: [77, 75, 202, 0.8],
                        outline: {
                            color: [255, 255, 255],
                            width: 1
                        }
                    };

                    // Create a new graphic for each feature in the response
                    const graphics = response.features.map((feature) => {
                        return new Graphic({
                            geometry: feature.geometry,
                            symbol: newSymbol
                        });
                    });

                    // Add the graphics to the map
                    graphics.forEach((graphic) => {
                        // console.log(graphic);
                        return that.mapService.mapView.graphics.add(graphic);
                    });
                    // console.log(graphics.length);
                    // Zoom to the first graphic
                    if (graphics.length > 0) {
                        // console.log(graphics[0]);
                        that.mapService.mapView.goTo(graphics);
                    }
                });
        }
    }

    async queryBaladeyaNames() {
        //   debugger;
        // console.log(`${this.mapService.baladiyaLayer}/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=BELEDIYE`)
        const queryUrl = `https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/8/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=BELEDIYE`; //${this.mapService.baladiyaLayer}
        const queryObject = new Query({
            where: '1=1',
            returnGeometry: true,
            outFields: ['BELEDIYE'],
            orderByFields: ['BELEDIYE']
        });
        // debugger;
        let results = await executeQueryJSON(queryUrl, queryObject);
        // executeQueryJSON(queryUrl, queryObject).then((results) => {
        this.baladyasList = results.features.map((feature) => {
            return {
                id: feature.attributes.BELEDIYE,
                name: feature.attributes.BELEDIYE,
                isChecked: false,
                info: '0',
                info2: 'مخطط',
                lable: feature.attributes.BELEDIYE,
                lable2: '%(0)'
            };
        });
        this.baladeyaNameOptions = results.features.map(
            (feature) => feature.attributes.BELEDIYE
        );
        results.features.forEach((feature) => {
            this.baladeyaGeometry[feature.attributes.BELEDIYE] =
                feature.geometry;
        });

        // console.log(this.baladeyaGeometry);
        // });
    }
    //  queryBaladeyaNames() {
    //         //   debugger;
    //         const queryUrl =
    //             'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/8/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=BELEDIYE';
    //         const queryObject = new Query({
    //             where: '1=1',
    //             returnGeometry: true,
    //             outFields: ['BELEDIYE']
    //         });

    //         executeQueryJSON(queryUrl, queryObject).then((results) => {
    //             this.baladeyaNameOptions = results.features.map(
    //                 (feature) => feature.attributes.BELEDIYE
    //             );
    //             results.features.forEach((feature) => {
    //                 this.baladeyaGeometry[feature.attributes.BELEDIYE] =
    //                     feature.geometry;
    //             });

    //             // console.log(this.baladeyaGeometry)
    //         });
    //     }
    queryNeighNames(baladeya: string) {
        const queryUrl = `https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/6/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=NEIGH_NAME`; //${this.mapService.neighRegLayer}
        const queryObject = new Query({
            where: `BELEDIYE = N'${baladeya}'`, // Assuming BELEDIYE is the field name for baladeya
            returnGeometry: true,
            outFields: ['NEIGH_NAME'],
            // orderByFields:['BELEDIYE']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.neighNameOptions = results.features.map(
                (feature) => feature.attributes.NEIGH_NAME
            );
            results.features.forEach((feature) => {
                this.neighGeom[feature.attributes.NEIGH_NAME] =
                    feature.geometry;
            });
        });
    }

    queryPlanNames(neigh: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=SUBDIVISIONNAME_AR';
        const queryObject = new Query({
            where: `Neigh_region = N'${neigh}'`,
            returnGeometry: true,
            outFields: ['SUBDIVISIONNAME_AR']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.planNameOptions = results.features.map(
                (feature) => feature.attributes.SUBDIVISIONNAME_AR
            );
            results.features.forEach((feature) => {
                this.planGeom[feature.attributes.SUBDIVISIONNAME_AR] =
                    feature.geometry;
            });
        });
    }

    queryPlanNum(neigh: string) {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=SUBDIVISIONPLAN_ID';
        const queryObject = new Query({
            where: `Neigh_region = N'${neigh}'`,
            returnGeometry: true,
            outFields: ['SUBDIVISIONPLAN_ID']
        });

        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.planNumOptions = results.features.map(
                (feature) => feature.attributes.SUBDIVISIONPLAN_ID
            );
            results.features.forEach((feature) => {
                this.planGeom[feature.attributes.SUBDIVISIONPLAN_ID] =
                    feature.geometry;
            });
        });
    }

    onBaladeyaNameChange(event: any) {
        const selectedBaladeya = event.target.value;
        // console.log(this.baladeyaGeometry[selectedBaladeya]);
        this.mapService.mapView.goTo(
            this.baladeyaGeometry[selectedBaladeya].extent
        );
        // debugger;
        this.queryNeighNames(selectedBaladeya);
    }
    onNeighNameChange(event: any) {
        const selectedNeigh = event.target.value;
        this.mapService.mapView.goTo(this.neighGeom[selectedNeigh].extent);
        //  this.queryPlanNames(selectedNeigh);
        this.queryPlanNum(selectedNeigh);
    }
    onPlanNameChange(event: any) {
        const selectedPlanName = event.target.value;
        this.mapService.mapView.goTo(this.planGeom[selectedPlanName].extent);
        //  this.queryPlanDetails(selectedPlan);
    }
    onPlanNumChange(event: any) {
        const selectedPlanNum = event.target.value;
        this.mapService.mapView.goTo(this.planGeom[selectedPlanNum].extent);
        //  this.queryPlanDetails(selectedPlan);
    }


    queryPlanCases() {
        const queryUrl =
            'https://144.76.146.59:6443/arcgis/rest/services/Amana/AmanaFinal/FeatureServer/5/query?f=pjson&where=1%3D1&returnGeometry=true&outFields=subdivision_status';
        const queryObject = new Query({
            where: `1=1`,
            returnGeometry: true,
            outFields: ['subdivision_status'],
            // groupByFieldsForStatistics:['subdivision_status']
        });
        const statusMapping = {
            1: "تم التصحيح",
            2: "جاري العمل",
            3: "ضبط الجودة",
            4: "مخالف للمعايير",
            5: "تم الاعتماد",
            6: "لم يتم العمل"
        };
        executeQueryJSON(queryUrl, queryObject).then((results) => {
            this.planCaseOptions = results.features
                .map((feature) => feature.attributes.subdivision_status)
                .filter((value, index, self) => self.indexOf(value) === index) // Ensure unique values
                .map((status) => statusMapping[status] || status); // Map to names

            // results.features.forEach((feature) => {
            //     console.log(feature)
            //     this.planGeom[feature.attributes.subdivision_status] = feature.geometry;
            //     console.log(this.planGeom)
            // });
        });
    }

    async onPlanCasesChange(event: any) {
        // this.planCaseFlag= true;

        const selectedCase = event.target.value;
        // console.log(selectedCase)
        if (!selectedCase) {
            // console.log(selectedCase)
            // this.plan.definitionExpression='';
            this.zoomToHome();
        }

        // Uncheck all checkboxes except "كل البلديات"
        this.baladyasList.forEach(baladiya => {
            baladiya.isChecked = false;
        });
        this.Allbaladeyas.isChecked = true; // Ensure "كل البلديات" is checked
        if (this.flagg) {
            this.baladeya.definitionExpression = '';
            this.plan.definitionExpression = `subdivision_status='${selectedCase}'`;
            console.log(this.plan.definitionExpression)
            this.neigh.definitionExpression = '';

            this.selectedBaladyaArr = [];
            await this.createSumAndCount(this.selectedBaladyaArr);
            // this.RERcount(this.selectedBaladyaArr);
            await this.comparisonStatus(this.selectedBaladyaArr);
            await this.planStatus(this.selectedBaladyaArr);
            await this.baladyPercentage(this.selectedBaladyaArr);
            await this.madinahPhotographyPercent(this.selectedBaladyaArr);
            if (this?.madinahInfoPie)
                this.madinahInfoPie.percentage = this.madinahPercent;
            if (this?.baladyInfoPie)
                this.baladyInfoPie.updateChartData(this.baladyPercent);
            if (this?.doneInfoPie)
                this.doneInfoPie.percentage = this.totalEnjaz;
            this?.getFakeData();
        }

        // Mapping from domain names to their corresponding numeric values
        const statusMapping = {
            'تم التصحيح': 1,
            'جاري العمل': 2,
            'ضبط الجودة': 3,
            'مخالف للمعايير': 4,
            'تم الاعتماد': 5,
            'لم يتم العمل': 6
        };
        // Get the corresponding numeric value
        const numericStatus = statusMapping[selectedCase];


        let graphics = [];
        this.mapService.mapView.graphics.removeAll();

        const planCaseQuery = {
            returnGeometry: true,
            outFields: ['subdivision_status'],
            // where: 'subdivision_status' + "='" + numericStatus + "'"
            where: `subdivision_status='${numericStatus}'`,

        };
        console.log(planCaseQuery)

        try {
            const response = await this.mapService.parBoundary.queryFeatures(planCaseQuery)
            //   .then(function (response) {
            // debugger;
            const newSymbol = {
                type: 'simple-fill',
                color: [51, 243, 255],//[77, 75, 202, 0.8],
                outline: {
                    color: [255, 255, 255],
                    width: 1
                }
            };

            // Create a new graphic for each feature in the response
            const g = response.features.map((feature) => {
                return graphics.push(new Graphic({
                    geometry: feature.geometry,
                    symbol: newSymbol
                }))
            });

            // Add the graphics to the map
            graphics.forEach((graphic) => {
                return this.mapService.mapView.graphics.add(graphic);
            });

            // Zoom to the first graphic
            if (graphics.length > 0) {
                //   console.log(graphics[0]);
                this.mapService.mapView.goTo(graphics);
            }
        }
        catch (error) {
            console.error("Error querying features:", error);
        }
        //   });
        // if (!this.planCaseFlag){
        //     event.target.value = ""; // Reset to "All" option
        //     this.planCaseFlag = false; // Reset the flag
        //    await this.onPlanCasesChange(event)
        // }
    }

    // takeScreenshot(): void {

    //     const element = document.getElementById('content');

    //     if (element) {
    //         html2canvas(element, {
    //             allowTaint: true,
    //             useCORS: true,
    //             scale: 1
    //         }).then(canvas => {
    //             const imgData = canvas.toDataURL('image/png');
    //             // console.log(imgData)
    //             // Create PDF using jsPDF
    //             const pdf = new jsPDF();//new jsPDF({orientation:"landscape",format:[1930, 950]})
    //             pdf.setFont('Arial');
    //             pdf.getFontSize();
    //             pdf.addImage(imgData, 'PNG', 7, 13, 195, 105);//pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height)
    //             // Save PDF
    //             pdf.save('Angular_Screenshot.pdf');
    //         });
    //     } else {
    //         console.error('Element not found');
    //     }
    // }

    //     printDocument(): void {



    //   // Get the element you want to hide
    //   const elementToHide = document.getElementById('elementToHide');

    //   // Hide the element
    //   if (elementToHide) {
    //       elementToHide.style.display = 'none';
    //   }

    //   // Print the document
    //   window.print();

    //   // Restore the element after a slight delay (this delay ensures print dialog opens first)
    //   setTimeout(() => {
    //       if (elementToHide) {
    //           elementToHide.style.display = 'block'; // Restore the element
    //       }
    //   }, 100); // Adjust the delay as needed




    //     }




    // printDocument() {



    //     const mapView = this.mapService.getMapView();
    //     if (!mapView) {
    //       console.error('MapView not found');
    //       return;
    //     }

    //     mapView.when(() => {
    //       // Step 1: Take a screenshot of the map using MapView.takeScreenshot
    //       mapView.takeScreenshot({ width: mapView.width, height: mapView.height })
    //         .then((screenshot) => {
    //           const mapImage = screenshot.dataUrl; // Data URL of the map image
    //           const htmlElement = this.contentRef.nativeElement; // Reference to the #content element

    //           // Step 2: Capture the rest of the HTML content
    //           toPng(htmlElement, { quality: 0.9 })
    //             .then((htmlImage) => {
    //               const pdf = new jsPDF('l', 'mm', 'a3');
    //               const x = 8;
    //               const y = 8;
    //               const imageWidth = pdf.internal.pageSize.getWidth() - 20;
    //               const pdfHeight = pdf.internal.pageSize.getHeight();

    //               // First, add the HTML content to the PDF
    //               let imageHeight = (htmlElement.offsetHeight * imageWidth) / htmlElement.offsetWidth;
    //               if (pdfHeight < imageHeight) {
    //                 let difference = imageHeight - pdfHeight;
    //                 pdf.internal.pageSize.height = pdfHeight + difference + 20;
    //               }
    //               pdf.addImage(htmlImage, 'JPEG', x, y, imageWidth, imageHeight);

    //               // Step 3: Add the captured map image to the PDF (scaled down)
    //               const mapScaleFactor =0.7;
    //               const scaledMapWidth = imageWidth * mapScaleFactor;
    //               const scaledMapHeight = (mapView.height * scaledMapWidth) / mapView.width;

    //               pdf.addImage(
    //                 mapImage, 'PNG',
    //                 10, 70, // Position the map
    //                 scaledMapWidth + 60, scaledMapHeight + 11, // Scaled size
    //                 '', 'FAST'
    //               );

    //               // Save the PDF
    //               pdf.save('map.pdf');
    //             })
    //             .catch((error) => {
    //               console.error('Error generating image:', error);
    //             });
    //         })
    //         .catch((error) => {
    //           console.error('Error taking screenshot of map:', error);
    //         });
    //     });
    //   }



    printDocument() {
        const mapView = this.mapService.getMapView();
        if (!mapView) {
            console.error('MapView not found');
            return;
        }

        mapView.when(() => {
            // Step 1: Take a screenshot of the map using MapView.takeScreenshot
            mapView.takeScreenshot({ width: mapView.width, height: mapView.height })
                .then((screenshot) => {
                    const mapImage = screenshot.dataUrl;  // Data URL of the map image

                    // If fullscreen, capture only the map and fill the entire PDF
                    if (this.fullscreen) {
                        const pdf = new jsPDF('l', 'mm', 'a3');
                        const pageWidth = pdf.internal.pageSize.getWidth();
                        const pageHeight = pdf.internal.pageSize.getHeight();

                        // Add the map image and fill the entire PDF page
                        pdf.addImage(mapImage, 'PNG', 0, 0, pageWidth, pageHeight, '', 'FAST');

                        // Save the PDF
                        pdf.save('map_fullscreen.pdf');
                    } else {
                        // Step 2: Capture the rest of the HTML content in normal mode
                        const htmlElement = this.contentRef.nativeElement;  // Reference to the #content element

                        toPng(htmlElement, { quality: 0.9 })
                            .then((htmlImage) => {
                                const pdf = new jsPDF('l', 'mm', 'a3');
                                const x = 8;
                                const y = 8;
                                const imageWidth = pdf.internal.pageSize.getWidth() - 20;
                                const pdfHeight = pdf.internal.pageSize.getHeight();

                                // First, add the HTML content to the PDF
                                let imageHeight = (htmlElement.offsetHeight * imageWidth) / htmlElement.offsetWidth;
                                if (pdfHeight < imageHeight) {
                                    let difference = imageHeight - pdfHeight;
                                    pdf.internal.pageSize.height = pdfHeight + difference + 20;
                                }
                                pdf.addImage(htmlImage, 'JPEG', x, y, imageWidth, imageHeight);

                                // Step 3: Add the captured map image to the PDF (scaled down)
                                const mapScaleFactor = 0.7;
                                const scaledMapWidth = imageWidth * mapScaleFactor;
                                const scaledMapHeight = (mapView.height * scaledMapWidth) / mapView.width;

                                pdf.addImage(
                                    mapImage, 'PNG',
                                    10, 70,  // Position the map below the HTML content
                                    scaledMapWidth + 60, scaledMapHeight + 11, // Scaled size for the map
                                    '', 'FAST'
                                );

                                // Save the PDF
                                pdf.save('map.pdf');
                            })
                            .catch((error) => {
                                console.error('Error generating image:', error);
                            });
                    }
                })
                .catch((error) => {
                    console.error('Error taking screenshot of map:', error);
                });
        });
    }




    measurementsVisible: boolean = true;
    toggleMeasurements() {
        this.measurementsVisible = !this.measurementsVisible
    }

}
